import React from "react";

const Descargos = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6 flex flex-col items-center">
      <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-4xl">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-700">DETALLE DEL PROCESO</h1>
          <p className="text-xl text-gray-500 mt-1">11001311002120210037100</p>
        </div>
        <div className="flex justify-between items-center mb-6">
          <div>
            <p className="text-gray-500">Fecha de consulta:</p>
            <p className="text-gray-700">2024-07-30 12:29:14.88</p>
          </div>
          <div>
            <p className="text-gray-500">Fecha de replicación de datos:</p>
            <p className="text-gray-700">2024-07-30 12:26:31.16</p>
          </div>
          <div className="flex space-x-4">
            <a
              href="/descargar/doc"
              className="flex items-center bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
            >
              Descargar DOC
            </a>
            <a
              href="/descargar/csv"
              className="flex items-center bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
            >
              Descargar CSV
            </a>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6">
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-700">DATOS DEL PROCESO</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                <p className="text-gray-500">Fecha de Radicación:</p>
                <p className="text-gray-700">2021-05-28</p>
              </div>
              <div>
                <p className="text-gray-500">Recurso:</p>
                <p className="text-gray-700">SIN TIPO DE RECURSO</p>
              </div>
              <div>
                <p className="text-gray-500">Despacho:</p>
                <p className="text-gray-700">JUZGADO 021 DE FAMILIA DE BOGOTÁ</p>
              </div>
              <div>
                <p className="text-gray-500">Ubicación del Expediente:</p>
                <p className="text-gray-700">DESPACHO</p>
              </div>
              <div>
                <p className="text-gray-500">Ponente:</p>
                <p className="text-gray-700">SANDRA ISABEL BERNAL CASTRO</p>
              </div>
              <div>
                <p className="text-gray-500">Contenido de Radicación:</p>
                <p className="text-gray-700">ADOPCION</p>
              </div>
              <div>
                <p className="text-gray-500">Tipo de Proceso:</p>
                <p className="text-gray-700">DE ADOPCION</p>
              </div>
              <div>
                <p className="text-gray-500">Clase de Proceso:</p>
                <p className="text-gray-700">SIN TIPO DE PROCESO</p>
              </div>
              <div>
                <p className="text-gray-500">Subclase de Proceso:</p>
                <p className="text-gray-700">SIN SUBCLASE DE PROCESO</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6">
            <h2 className="text-lg font-semibold text-gray-700">SUJETOS PROCESALES</h2>
            {/* Aquí iría la información de los sujetos procesales */}
          </div>
          <div className="border-t border-gray-200 pt-6">
            <h2 className="text-lg font-semibold text-gray-700">DOCUMENTOS DEL PROCESO</h2>
            {/* Aquí iría la información de los documentos del proceso */}
          </div>
          <div className="border-t border-gray-200 pt-6">
            <h2 className="text-lg font-semibold text-gray-700">ACTUACIONES</h2>
            {/* Aquí iría la información de las actuaciones */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Descargos;
